var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 37,
    viewBox: "0 0 27 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.53906 1.96875 0.5 4.5 0.5H15.4688C16.3125 0.5 17.2266 0.921875 17.8594 1.55469L25.9453 9.64062C26.5781 10.2734 27 11.1875 27 12.0312V32C27 34.5312 24.9609 36.5 22.5 36.5H4.5C1.96875 36.5 0 34.5312 0 32V5ZM24.75 14H16.875C14.9766 14 13.5 12.5234 13.5 10.625V2.75H4.5C3.23438 2.75 2.25 3.80469 2.25 5V32C2.25 33.2656 3.23438 34.25 4.5 34.25H22.5C23.6953 34.25 24.75 33.2656 24.75 32V14ZM24.3984 11.2578L16.2422 3.10156C16.1016 2.96094 15.8906 2.89062 15.75 2.82031V10.625C15.75 11.2578 16.2422 11.75 16.875 11.75H24.6797C24.6094 11.6094 24.5391 11.3984 24.3984 11.2578Z",
    fill: "#DDDDDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.d682dc483738361651a8d47d6f0f3297.svg";
export { ForwardRef as ReactComponent };